import React, {useState} from 'react'
import {Button} from 'react-bootstrap'
import {useNavigate} from "react-router-dom";
import styled, {keyframes} from "styled-components";

interface Props {
    message: string
    url?: string
    onClick?: () => void
    disabled?: boolean
}

const BooksitoutButton: React.FC<Props> = ({message, url, onClick, disabled}) => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const onClickHandler = (e) => {
        if (isLoading) {
            e?.preventDefault()
            return
        }

        if (url || onClick) {
            e?.preventDefault()
        }

        if (url) {
            navigate(url)
            return
        }

        if (onClick) {
            onClick()
            return
        }

        // form submit (no onClick) — show loading briefly
        setIsLoading(true)
        setTimeout(() => setIsLoading(false), 3000)
    }

    return (
        <StyledButton
            onClick={onClickHandler}
            variant={'book'}
            type={'submit'}
            href={url}
            disabled={disabled}
            $dimmed={isLoading || (disabled ?? false)}
        >
            {isLoading ? (
                <DotsContainer>
                    <Dot $delay={0} />
                    <Dot $delay={0.15} />
                    <Dot $delay={0.3} />
                </DotsContainer>
            ) : (
                message
            )}
        </StyledButton>
    )
}

interface StyledButtonProps {
    $dimmed: boolean
}

const StyledButton = styled(Button)<StyledButtonProps>`
    height: 48px;
    padding: 0 24px;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    border-radius: 16px;
    opacity: ${({ $dimmed }) => ($dimmed ? '0.6' : '1')};
    transition: color 0.1s ease-in-out, background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
`

const bounce = keyframes`
    0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.4;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
`

const DotsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
`

interface DotProps {
    $delay: number
}

const Dot = styled.div<DotProps>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #fff;
    animation: ${bounce} 1s ease-in-out infinite;
    animation-delay: ${({ $delay }) => $delay}s;
`

export default BooksitoutButton
